
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-disclaimer",
  components: {},
})
export default class IconDisclaimer extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
